import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["primaryCheckBox", "hiddenFieldsWrapper"];

  connect() {
    this.hiddenFields = Array.from(
      this.hiddenFieldsWrapperTarget.querySelectorAll(".pcd-field")
    );

    if (!this.primaryCheckBoxTarget.checked) {
      this.hideFields();
    }
  }

  togglePCD() {
    if (this.primaryCheckBoxTarget.checked) {
      this.showFields();
    } else {
      this.hideFields();
    }
  }

  showFields() {
    this.hiddenFieldsWrapperTarget.classList.remove("d-none");

    this.hiddenFields.forEach((field) => {
      this.hiddenFieldsWrapperTarget.appendChild(field);
    });
  }

  hideFields() {
    this.hiddenFieldsWrapperTarget.classList.add("d-none");

    this.hiddenFields.forEach((field) => {
      field.remove();
    });
  }
}
